export default __webpack_public_path__ + "static/media/icon_erro.163c9e7b.svg";